export { default } from './ScheduleAssignDepartment.js';